// sapi-admin/src/components/AdminAvatarMenu.jsx
import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import { Users, LogOut } from 'lucide-react';
import { toast } from 'react-toastify';

export default function AdminAvatarMenu() {
    const [isOpen, setIsOpen] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, right: 0 });
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);
    
    useEffect(() => {
    const handleClickOutside = (event) => {
        if (
        buttonRef.current?.contains(event.target) ||
        dropdownRef.current?.contains(event.target)
        ) return;
        setIsOpen(false);
    };
    if (isOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen]);
  
    const handleLogout = () => {
        toast.success("Logged out successfully!");
        window.location.href = "/login";
    };
    
    // Update dropdown position when opening
    useEffect(() => {
        if (isOpen && buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setDropdownPosition({
        top: rect.bottom + 8,
        right: window.innerWidth - rect.right,
      });
    }
  }, [isOpen]);

  const DropdownContent = () => (
    <div
      ref={dropdownRef}
      style={{
        position: 'fixed',
        top: `${dropdownPosition.top}px`,
        right: `${dropdownPosition.right}px`,
        width: '200px',
        zIndex: 99999,
      }}
      className="bg-[#0d1526] border border-white/[0.08] rounded-xl shadow-2xl overflow-hidden"
    >
      <div className="py-2">
        <div className="px-4 py-2 border-b border-white/[0.06]">
          <p className="text-xs font-semibold text-white">Administrator</p>
          <p className="text-[9px] text-slate-500">Super Admin</p>
        </div>

        <Link
          to="/profile"
          onClick={() => setIsOpen(false)}
          className="flex items-center gap-2 px-4 py-2 text-xs text-slate-400 hover:text-white hover:bg-white/[0.05] transition"
        >
          <Users size={12} /> My Profile
        </Link>

        <Link
          to="/settings"
          onClick={() => setIsOpen(false)}
          className="flex items-center gap-2 px-4 py-2 text-xs text-slate-400 hover:text-white hover:bg-white/[0.05] transition"
        >
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
            />
            <circle cx="12" cy="12" r="3" />
          </svg>
          Settings
        </Link>

        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-2 px-4 py-2 text-xs text-red-400 hover:text-red-300 hover:bg-red-500/10 transition"
        >
          <LogOut size={12} /> Sign Out
        </button>
      </div>
    </div>
  );

  return (
    <div className="relative">
      {/* Avatar button */}
      <button
        ref={buttonRef}
        onClick={() => setIsOpen(!isOpen)}
        className="w-8 h-8 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center text-[10px] font-bold text-white cursor-pointer ring-2 ring-amber-500/30 hover:ring-amber-500/60 transition-all"
      >
        AD
      </button>

      {/* Render dropdown using Portal */}
      {isOpen && ReactDOM.createPortal(
      <div
        ref={dropdownRef}
        style={{
          position: 'fixed',
          top: `${dropdownPosition.top}px`,
          right: `${dropdownPosition.right}px`,
          width: '200px',
          zIndex: 99999,
        }}
        className="bg-[#0d1526] border border-white/[0.08] rounded-xl shadow-2xl overflow-hidden"
      >
        <div className="py-2">
          <div className="px-4 py-2 border-b border-white/[0.06]">
            <p className="text-xs font-semibold text-white">Administrator</p>
            <p className="text-[9px] text-slate-500">Super Admin</p>
          </div>
          <Link to="/profile" onClick={() => setIsOpen(false)} className="flex items-center gap-2 px-4 py-2 text-xs text-slate-400 hover:text-white hover:bg-white/[0.05] transition">
            <Users size={12} /> My Profile
          </Link>
          <button onClick={handleLogout} className="w-full flex items-center gap-2 px-4 py-2 text-xs text-red-400 hover:text-red-300 hover:bg-red-500/10 transition">
            <LogOut size={12} /> Sign Out
          </button>
        </div>
      </div>,
      document.body
    )}
  </div>
);
}